// Custom Console Logger for Variant Picker Debugging
// This file automatically saves console logs to a local file for easier debugging

(function() {
  'use strict';
  
  // Store original console methods
  const originalLog = console.log;
  const originalError = console.error;
  const originalWarn = console.warn;
  
  // Create log buffer
  let logBuffer = [];
  let isInitialized = false;
  
  // Initialize logger
  function initLogger() {
    if (isInitialized) return;
    
    // Add timestamp to all logs
    const timestamp = new Date().toISOString();
    logBuffer.push(`=== CONSOLE LOG START: ${timestamp} ===`);
    logBuffer.push(`URL: ${window.location.href}`);
    logBuffer.push(`User Agent: ${navigator.userAgent}`);
    logBuffer.push('=====================================');
    
    // Override console.log
    console.log = function(...args) {
      const message = args.map(arg => 
        typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
      ).join(' ');
      
      logBuffer.push(`[LOG] ${message}`);
      originalLog.apply(console, args);
    };
    
    // Override console.error
    console.error = function(...args) {
      const message = args.map(arg => 
        typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
      ).join(' ');
      
      logBuffer.push(`[ERROR] ${message}`);
      originalError.apply(console, args);
    };
    
    // Override console.warn
    console.warn = function(...args) {
      const message = args.map(arg => 
        typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
      ).join(' ');
      
      logBuffer.push(`[WARN] ${message}`);
      originalWarn.apply(console, args);
    };
    
    // Add save function to window for manual saving
    window.saveConsoleLogs = function() {
      const logContent = logBuffer.join('\n');
      const blob = new Blob([logContent], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.href = url;
      a.download = `console-log-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      // console.log('Console logs saved to file');
    };
    
    // Auto-save every 30 seconds - DISABLED
    // setInterval(() => {
    //   if (logBuffer.length > 0) {
    //     window.saveConsoleLogs();
    //     logBuffer = []; // Clear buffer after saving
    //   }
    // }, 30000);
    
    // Save on page unload - DISABLED
    // window.addEventListener('beforeunload', () => {
    //   if (logBuffer.length > 0) {
    //     window.saveConsoleLogs();
    //   }
    // });
    
    isInitialized = true;
    // originalLog('Console logger initialized. Use window.saveConsoleLogs() to save logs manually.');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogger);
  } else {
    initLogger();
  }
  
})(); 